import React from 'react';
import PillButton from '../../Button/PillButton';

/**
 * PillGroup - Molecular component for pill button groups
 * @param {Object} props
 * @param {Array<string|{value: string, label: string}>} props.options - Array of options
 * @param {string|Array<string>} props.selected - Selected value(s)
 * @param {Function} props.onSelect - Callback when option is selected
 * @param {boolean} props.multiple - Allow multiple selections
 * @param {string} props.size - Size of pill buttons ('xs', 'xs2', 'sm', 'md')
 * @param {string} props.className - Additional CSS classes
 */
export const PillGroup = ({
    options = [],
    selected,
    onSelect,
    multiple = false,
    size = 'xs2',
    className = ''
}) => {
    const isSelected = (option) => {
        const value = typeof option === 'string' ? option : option.value;

        if (multiple) {
            return Array.isArray(selected) && selected.includes(value);
        }
        return selected === value;
    };

    const handleSelect = (option) => {
        const value = typeof option === 'string' ? option : option.value;

        if (multiple) {
            const currentSelected = Array.isArray(selected) ? selected : [];
            const newSelected = currentSelected.includes(value)
                ? currentSelected.filter(v => v !== value)
                : [...currentSelected, value];
            onSelect(newSelected);
        } else {
            onSelect(value);
        }
    };

    return (
        <div className={`flex flex-wrap gap-2.5 ${className}`}>
            {options.map((option) => {
                const value = typeof option === 'string' ? option : option.value;
                const label = typeof option === 'string' ? option : option.label;

                return (
                    <PillButton
                        key={value}
                        selected={isSelected(option)}
                        size={size}
                        onClick={(e) => {
                            e.preventDefault();
                            handleSelect(option);
                        }}
                    >
                        {label}
                    </PillButton>
                );
            })}
        </div>
    );
};

export default PillGroup;
